// App.js
import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ProfilePage from './pages/ProfilePage';
import PasswordPage from './pages/PasswordPage';
import CourseSubjects from './pages/CourseSubjects';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundPage from './pages/RefundPage';
import SubjectDetails from './pages/SubjectDetails';
import SidebarLayout from './pages/SidebarLayout';
import MyCourse from './pages/MyCourse';
import AccessCourse from './pages/AccessCourse';
import ELearningModulePage from './pages/ELearningModulePage';
import Layout from './components/Layout';
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import { ToastContainer } from 'react-toastify';

function AppContent() {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const isAuthenticated = !!user;

  return (
    <>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* Public Routes */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/subjects" element={<Layout><CourseSubjects /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
          <Route path="/refund" element={<Layout><RefundPage /></Layout>} />
          <Route path="/subjects_details/:id" element={<Layout><SubjectDetails /></Layout>} />
          <Route path="/LoginPage" element={<LoginPage />} />
          <Route path="/SignupPage" element={<SignupPage />} />
          <Route path="/ForgotPasswordPage" element={<ForgotPasswordPage />} />
          <Route path="/ProfilePage" element={<ProfilePage />} />
          <Route path="/PasswordPage" element={<PasswordPage />} />
          <Route path="elearning/:subjectId" element={<ELearningModulePage />} />

          {/* Protected Routes inside SidebarLayout */}
          {isAuthenticated ? (
            <Route path="/" element={<SidebarLayout />}>
              <Route path="mycourse" element={<MyCourse />} />
              <Route path="course/:courseId" element={<AccessCourse />} />
            </Route>
          ) : (
            // Redirect any protected route if not authenticated
            <Route path="*" element={<Navigate to="/LoginPage" replace />} />
          )}
        </Routes>
        <PWAInstallPrompt />
        <ToastContainer position="top-center" />
      </AnimatePresence>
    </>
  );
}

const App = () => {
  return <AppContent />; // ✅ No <Router> here
};

export default App;
